import { createSlice } from "@reduxjs/toolkit";
import { resetAll } from "./baseSlice";
import intl from "../../i18n/intl";
import { toast } from "react-toastify";

const initialState = {
  data: [],
  record: null,
  requesting: false,
  error: null,
  action: null,
  dropdown: [],     // <-- add this
  query: {
    pageNo: 1,
    pageSize: 50,
    sortBy: "asc",
    sortColumn: "name",
    namePattern: "",
  },
};

const customIntl = intl();

const rolesSlice = createSlice({
  name: "roles",
  initialState,
  extraReducers: (builder) => builder.addCase(resetAll, () => initialState),
  reducers: {
    listRequest: (state, action) => {
      state.requesting = true;
      state.error = null;
      state.action = "list";
      state.record = null;
    },
    listSuccess: (state, action) => {
      state.data = action.payload.response;
      state.requesting = false;
      state.error = null;
    },
    listFail: (state, action) => {
      state.data = [];
      state.requesting = false;
      state.error = action.payload;
    },
    setQuery: (state, action) => {
      state.query = {
        ...state.query,
        ...action.payload,
      };
    },
    createRequest: (state, action) => {
      state.requesting = true;
      state.error = null;
      state.action = "create";
    },
    createSuccess: (state, action) => {
      state.requesting = false;
      state.error = null;
      toast.success(customIntl.formatMessage({ id: "role_create_success" }));
    },
    createFail: (state, action) => {
      state.requesting = false;
      state.error = action.payload;
      if (action.payload.status !== 400 && action.payload.status !== 401) {
        toast.error(customIntl.formatMessage({ id: "something_else_wrong" }));
      }
    },
    detailsRequest: (state, action) => {
      state.requesting = true;
      state.error = null;
      state.action = "details";
      state.record = null;
    },
    detailsSuccess: (state, action) => {
      state.record = action.payload.response;
      state.requesting = false;
      state.error = null;
    },
    detailsFail: (state, action) => {
      state.record = null;
      state.requesting = false;
      state.error = action.payload;
      if (action.payload.status !== 400 && action.payload.status !== 401) {
        toast.error(customIntl.formatMessage({ id: "something_else_wrong" }));
      }
    },
    updateDetailRequest: (state, action) => {
      state.requesting = true;
      state.error = null;
      state.action = "update";
    },
    updateDetailSuccess: (state, action) => {
      state.requesting = false;
      state.error = null;
      toast.success(
        customIntl.formatMessage(
          { id: "action_success" },
          {
            action: customIntl.formatMessage({ id: "update_performed" }),
            object: customIntl.formatMessage({ id: "role" }),
          }
        )
      );
    },
    updateDetailFail: (state, action) => {
      state.requesting = false;
      state.error = action.payload;
      if (action.payload.status !== 400 && action.payload.status !== 401) {
        toast.error(customIntl.formatMessage({ id: "something_else_wrong" }));
      }
    },
    userListRequest: (state, action) => {
      state.requesting = true;
      state.error = null;
      state.action = "userList";
      state.users = [];
    },
    userListSuccess: (state, action) => {
      state.users = action.payload.response;
      state.requesting = false;
      state.error = null;
    },
    userListFail: (state, action) => {
      state.requesting = false;
      state.error = action.payload;
    },
    exportRequest: (state, action) => {
      state.requesting = true;
      state.error = null;
      state.action = "export";
    },
    exportSuccess: (state, action) => {
      state.requesting = false;
      state.error = null;
    },
    exportFail: (state, action) => {
      state.requesting = false;
      state.error = action.payload;
    },
    dropdownRequest: (state) => {
      state.requesting = true;
      state.error = null;
      state.action = "dropdown";
      state.dropdown = []; // store dropdown list

    },
    dropdownSuccess: (state, action) => {
      state.dropdown = action.payload.response || action.payload; // handle array directly
      state.requesting = false;
      state.error = null;
    },
    dropdownFail: (state, action) => {
      state.dropdown = [];
      state.requesting = false;
      state.error = action.payload;
    },
     getRolesRequest: (state) => {
      state.requesting = true;
      state.error = null;
      state.action = "getRoles";
      state.allRoles = []; // store dropdown list

    },
    getRolesSuccess: (state, action) => {
      state.allRoles = action.payload.response || action.payload; // handle array directly
      state.requesting = false;
      state.error = null;
    },
    getRolesFail: (state, action) => {
      state.allRoles = [];
      state.requesting = false;
      state.error = action.payload;
    },

  },
});

export const {
  createFail,
  createRequest,
  createSuccess,
  listFail,
  listRequest,
  listSuccess,
  detailsFail,
  detailsRequest,
  detailsSuccess,
  setQuery,
  updateDetailFail,
  updateDetailRequest,
  updateDetailSuccess,
  userListFail,
  userListRequest,
  userListSuccess,
  exportFail,
  exportRequest,
  exportSuccess,
  dropdownRequest,   
  dropdownSuccess,   
  dropdownFail,
  getRolesRequest,
  getRolesSuccess,
  getRolesFail    
} = rolesSlice.actions;
export default rolesSlice.reducer;
